module.exports = __webpack_public_path__ + "static/focus_groupes-8de9ce8b1c9d4508b4ac49cfc796977a.png";